module.exports = __webpack_public_path__ + "static/media/badge_verified.50af0ca1.svg";